export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  // Ao resolver uma conversa com negócio aberto no funil → abre o card de ação
  RESOLVE_DEAL_PROMPT: 'RESOLVE_DEAL_PROMPT',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  WHATSAPP_QRCODE_UPDATED: 'whatsappQrCodeUpdated',
  CONFIG_ASSISTANT_UPDATED: 'configAssistantUpdated',
  WHATSAPP_CONNECTION_UPDATE: 'whatsappConnectionUpdate',
  // Chat Room events
  CHAT_ROOM_MESSAGE_CREATED: 'chat_room_message.created',
  CHAT_ROOM_MESSAGE_UPDATED: 'chat_room_message.updated',
  CHAT_ROOM_DELETED: 'chat_room.deleted',
  CHAT_ROOM_MEMBER_ADDED: 'chat_room.member_added',
  CHAT_ROOM_MEMBER_REMOVED: 'chat_room.member_removed',
};
